// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountSettings {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  overflow: auto;
  position: relative;
}
.AccountSettings .Details {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background: var(--Foreground);
  width: 19rem;
  border-radius: 1rem;
}
.AccountSettings .Details .Logo {
  height: 7.5rem;
  width: 100%;
  background: var(--AccentColor);
  position: relative;
  border-radius: 1rem 1rem 0 0;
}
.AccountSettings .Details .Logo div {
  position: absolute;
  top: 3.75rem;
  left: 50%;
  transform: translateX(-50%);
  border: 1px solid var(--Stroke);
  height: 100%;
  aspect-ratio: 1/1;
  background: var(--Foreground);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.AccountSettings .Details .Logo div img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.AccountSettings .Details .Logo div span {
  color: var(--Pending);
  font-size: 4rem;
  font-weight: 700;
  text-transform: uppercase;
}
.AccountSettings .Details .Logo div .EditLogo {
  position: absolute;
  bottom: 0;
  height: 2.5rem;
  width: 100%;
  background: var(--Stroke);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
}
.AccountSettings .Details .Logo div .EditLogo span {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.AccountSettings .Details .Logo div .EditLogo svg path {
  fill: var(--TextColor);
}
.AccountSettings .Details .Logo div .Hide {
  display: none;
}
.AccountSettings .Details .DetailsContainer {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 0.75rem 0.75rem 0.75rem;
  width: 100%;
}
.AccountSettings .Details .DetailsContainer h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--TextColor);
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.AccountSettings .Details .DetailsContainer span {
  font-size: 0.75rem;
  text-align: center;
  text-wrap: balance;
  color: var(--TextColor);
}
.AccountSettings .Details .DetailsContainer .Description {
  font-size: 0.75rem;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  color: var(--TextColor);
}
.AccountSettings .Details .DetailsContainer .Detail {
  margin-top: 2.5rem;
  width: 100%;
  padding: 0 0.625rem 0 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1.25rem;
}
.AccountSettings .Details .DetailsContainer .Detail div {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1.25rem;
  overflow: hidden;
}
.AccountSettings .Details .DetailsContainer .Detail div svg {
  min-width: 1.25rem;
}
.AccountSettings .Details .DetailsContainer .Detail div svg path {
  fill: var(--AccentColor);
}
.AccountSettings .Details .DetailsContainer .Detail div span {
  font-size: 0.875rem;
  color: var(--TextColor);
  font-weight: 400;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AccountSettings .Details .DetailsContainer .Detail div .Address {
  font-size: 0.875rem;
  color: var(--TextColor);
  font-weight: 400;
  text-align: left;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.AccountSettings .Informations {
  flex: 1 1;
  background: var(--Foreground);
  border-radius: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}
.AccountSettings .Informations .InformationContainer {
  flex: 1 1;
  width: calc(100% - 1.25rem);
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.AccountSettings .Informations .InformationContainer .InformationHeader {
  width: 100%;
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.0625rem solid var(--AccentColor);
}
.AccountSettings .Informations .InformationContainer .InformationHeader .Tabs {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 2rem;
}
.AccountSettings .Informations .InformationContainer .InformationHeader .Tabs span {
  color: #9b9b9b;
  font-weight: 500;
  line-height: 2.5rem;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.AccountSettings .Informations .InformationContainer .InformationHeader .Tabs .Tab {
  color: var(--TextColor);
  font-weight: 500;
  position: relative;
  transition: all 0.3s ease;
}
.AccountSettings .Informations .InformationContainer .InformationHeader .Tabs .Tab::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.25rem;
  background: var(--AccentColor);
}
.AccountSettings .Informations .InformationContainer .InformationHeader .Tabs .NotAllowed {
  cursor: not-allowed;
}
.AccountSettings .Informations .InformationContainer .InformationHeader span {
  color: var(--AccentColor);
  font-size: 0.875rem;
  font-weight: 400;
  cursor: pointer;
}
.AccountSettings .Informations .InformationContainer .InformationHeader .SaveCancel {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.5rem;
}
.AccountSettings .Informations .InformationContainer .InformationHeader .SaveCancel span:nth-child(1) {
  color: #C4C4C4;
}
.AccountSettings .Informations .InformationContainer .Information {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: auto;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccHeader {
  padding: 0.375rem 0.5rem;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccHeader span {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--TextColor);
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper {
  width: 100%;
  display: grid;
  grid-template-rows: 1fr;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo {
  width: 100%;
  margin: 0.75rem 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.25rem;
  overflow: hidden;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div label {
  font-size: 0.75rem;
  color: var(--AccentColor);
  font-weight: 400;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div input {
  width: calc(100% - 1.5rem);
  padding: 0 0.75rem;
  background: var(--Invitation);
  color: var(--TextColor);
  border: none;
  height: 32px;
  border-bottom: 2px solid var(--Stroke);
  font-size: 0.875rem;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div input:read-only {
  opacity: 0.5;
  cursor: not-allowed;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div select {
  width: calc(100% - 1.5rem);
  padding: 0 0.75rem;
  background: var(--Invitation);
  border: none;
  height: 32px;
  border-bottom: 2px solid var(--Stroke);
  color: var(--TextColor);
  font-size: 0.875rem;
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div select option {
  background: var(--Foreground);
}
.AccountSettings .Informations .InformationContainer .Information .Accordion .AccInfoWrapper .AccInfo div span {
  font-size: 0.875rem;
  color: #C4C4C4;
}
.AccountSettings .Informations .InformationContainer .Documents {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0.75rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  grid-template-rows: repeat(auto-fill, 10rem);
  gap: 1rem;
}
.AccountSettings .Informations .InformationContainer .Documents .DocCont {
  height: 10rem;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  border: 0.0625rem solid var(--Background);
}
.AccountSettings .Informations .InformationContainer .Documents .DocCont .Document {
  flex: 1 1;
  padding: 0.5rem;
  overflow: hidden;
}
.AccountSettings .Informations .InformationContainer .Documents .DocCont .Document img {
  width: 100%;
}
.AccountSettings .Informations .InformationContainer .Documents .DocDetail {
  width: 100%;
  padding: 0 0.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.AccountSettings .Informations .InformationContainer .Documents .DocDetail .DocName {
  flex: 1 1;
  font-size: clamp(0.625rem, 1vw, 0.875rem);
  font-weight: 700;
  color: var(--TextColor);
  white-space: nowrap;
}
.AccountSettings .Informations .InformationContainer .Documents .DocDetail svg {
  cursor: pointer;
}
.AccountSettings .Informations .InformationContainer .Documents .DocDetail svg path {
  fill: var(--TextColor);
}
.AccountSettings .Informations .InformationContainer .Documents .DocDetail svg:hover path {
  fill: var(--AccentColor);
}
.AccountSettings .LoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(44, 44, 44, 0.3137254902);
  z-index: 1;
}

@media (max-width: 650px) {
  .AccountSettings {
    flex-direction: column;
  }
  .AccountSettings .Details {
    height: auto;
    width: 100%;
  }
  .AccountSettings .Details .DetailsContainer .Detail {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  }
  .AccountSettings .Details .DetailsContainer .Detail div {
    align-items: center;
  }
  .AccountSettings .Informations {
    width: 100%;
    height: auto;
  }
}
@media (max-width: 450px) {
  .AccountSettings .Details .DetailsContainer .Detail {
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  }
}
@media (max-height: 450px) {
  .AccountSettings .Details .Logo {
    height: 5rem;
  }
  .AccountSettings .Details .Logo div {
    top: 2.5rem;
  }
  .AccountSettings .Details .DetailsContainer {
    padding: 3rem 0.75rem 0.75rem 0.75rem;
    overflow: auto;
  }
  .AccountSettings .Details .DetailsContainer .Detail {
    margin-top: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AccountSettings/AccountSettings.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AACF;AAAE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;AAEJ;AADI;EACE,cAAA;EACA,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,4BAAA;AAGN;AAFM;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,+BAAA;EACA,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAIR;AAHQ;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAKV;AAHQ;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAKV;AAHQ;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;AAKV;AAJU;EACE,kBAAA;EACA,uBAAA;AAMZ;AAHY;EACE,sBAAA;AAKd;AADQ;EACE,aAAA;AAGV;AACI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qCAAA;EACA,WAAA;AACN;AAAM;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAER;AAAM;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAER;AAAM;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AAER;AAAM;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;AAER;AADQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAGV;AAFU;EACE,kBAAA;AAIZ;AAHY;EACE,wBAAA;AAKd;AAFU;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAIZ;AAFU;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAIZ;AAEE;EACE,SAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAAJ;AACI;EACE,SAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AACN;AAAM;EACE,WAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iDAAA;AAER;AADQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAGV;AAFU;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAIZ;AAFU;EACE,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAIZ;AAFU;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,8BAAA;AAIZ;AAFU;EACE,mBAAA;AAIZ;AADQ;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAGV;AADQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAGV;AAFU;EACE,cAAA;AAIZ;AAAM;EACE,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;AAER;AADQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAGV;AAFU;EACE,wBAAA;AAIZ;AAHY;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKd;AAFU;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;AAIZ;AAHY;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,4DAAA;EACA,YAAA;EACA,gBAAA;AAKd;AAJc;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAMhB;AALgB;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;AAOlB;AALgB;EACE,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;AAOlB;AALgB;EACE,YAAA;EACA,mBAAA;AAOlB;AALgB;EACE,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,uBAAA;EACA,mBAAA;AAOlB;AANkB;EACE,6BAAA;AAQpB;AALgB;EACE,mBAAA;EACA,cAAA;AAOlB;AAAM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,2DAAA;EACA,4CAAA;EACA,SAAA;AAER;AADQ;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,yCAAA;AAGV;AAFU;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAIZ;AAHY;EACE,WAAA;AAKd;AADQ;EACA,WAAA;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAGV;AAFU;EACE,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAIZ;AAFU;EACE,eAAA;AAIZ;AAHY;EACE,sBAAA;AAKd;AADY;EACE,wBAAA;AAGd;AAIE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;EACA,UAAA;AAFJ;;AAMA;EACE;IACE,sBAAA;EAHF;EAIE;IACE,YAAA;IACA,WAAA;EAFJ;EAIM;IACE,aAAA;IACA,2DAAA;EAFR;EAGQ;IACE,mBAAA;EADV;EAME;IACE,WAAA;IACA,YAAA;EAJJ;AACF;AAQA;EAIQ;IACE,2DAAA;EATR;AACF;AAeA;EAGM;IACE,YAAA;EAfN;EAgBM;IACE,WAAA;EAdR;EAiBI;IACE,qCAAA;IACA,cAAA;EAfN;EAgBM;IACE,gBAAA;IACA,2DAAA;EAdR;AACF","sourcesContent":[".AccountSettings{\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  overflow: auto;\n  position: relative;\n  .Details{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100%;\n    background: var(--Foreground);\n    width: 19rem;\n    border-radius: 1rem;\n    .Logo{\n      height: 7.5rem;\n      width: 100%;\n      background: var(--AccentColor);\n      position: relative;\n      border-radius: 1rem 1rem 0 0;\n      div{\n        position: absolute;\n        top: 3.75rem;\n        left: 50%;\n        transform: translateX(-50%);\n        border: 1px solid var(--Stroke);\n        height: 100%;\n        aspect-ratio: 1 / 1;\n        background: var(--Foreground);\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        overflow: hidden;\n        img{\n          height: 100%;\n          width: 100%;\n          object-fit: cover;\n        }\n        span{\n          color: var(--Pending);\n          font-size: 4rem;\n          font-weight: 700;\n          text-transform: uppercase;\n        }\n        .EditLogo{\n          position: absolute;\n          bottom: 0;\n          height: 2.5rem;\n          width: 100%;\n          background: var(--Stroke);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          gap: 0.5rem;\n          cursor: pointer;\n          span{\n            font-size: 0.75rem;\n            color: var(--TextColor);\n          }\n          svg{\n            path{\n              fill: var(--TextColor);\n            }\n          }\n        }\n        .Hide{\n          display: none;\n        }\n      }\n    }\n    .DetailsContainer{\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding: 5rem 0.75rem 0.75rem 0.75rem;\n      width: 100%;\n      h1{\n        margin: 0;\n        font-size: 1.5rem;\n        font-weight: 600;\n        color: var(--TextColor);\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        text-align: center;\n      }\n      span{\n        font-size: 0.75rem;\n        text-align: center;\n        text-wrap: balance;\n        color: var(--TextColor);\n      }\n      .Description{\n        font-size: 0.75rem;\n        text-align: center;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 100%;\n        color: var(--TextColor);\n      }\n      .Detail{\n        margin-top: 2.5rem;\n        width: 100%;\n        padding: 0 0.625rem 0 1.25rem;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n        gap: 1.25rem;\n        div{\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n          align-items: flex-start;\n          gap: 1.25rem;\n          overflow: hidden;\n          svg{\n            min-width: 1.25rem;\n            path{\n              fill: var(--AccentColor);\n            }\n          }\n          span{\n            font-size: 0.875rem;\n            color: var(--TextColor);\n            font-weight: 400;\n            text-align: left;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n          .Address{\n            font-size: 0.875rem;\n            color: var(--TextColor);\n            font-weight: 400;\n            text-align: left;\n            white-space: wrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n    }\n  }\n  .Informations{\n    flex: 1;\n    background: var(--Foreground);\n    border-radius: 1rem;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow: auto;\n    .InformationContainer{\n      flex: 1;\n      width: calc(100% - 1.25rem);\n      padding: 0.75rem;\n      display: flex;\n      flex-direction: column;\n      gap: 0.75rem;\n      overflow: auto;\n      .InformationHeader{\n        width: 100%;\n        height: 2.5rem;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        border-bottom: 0.0625rem solid var(--AccentColor);\n        .Tabs{\n          flex: 1;\n          display: flex;\n          align-items: center;\n          gap: 2rem;\n          span{\n            color: #9b9b9b;\n            font-weight: 500;\n            line-height: 2.5rem;\n            transition: all 0.3s ease;\n            white-space: nowrap;\n          }\n          .Tab{\n            color: var(--TextColor);\n            font-weight: 500;\n            position: relative;\n            transition: all 0.3s ease;\n          }\n          .Tab::after{\n            content: '';\n            position: absolute;\n            left: 0;\n            bottom: 0;\n            width: 100%;\n            height: 0.25rem;\n            background: var(--AccentColor);\n          }\n          .NotAllowed{\n            cursor: not-allowed;\n          }\n        }\n        span{\n          color: var(--AccentColor);\n          font-size: 0.875rem;\n          font-weight: 400;\n          cursor: pointer;\n        }\n        .SaveCancel{\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 2.5rem;\n          span:nth-child(1){\n            color: #C4C4C4;\n          }\n        }\n      }\n      .Information{\n        flex: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        overflow: auto;\n        .Accordion{\n          display: flex;\n          flex-direction: column;\n          width: 100%;\n          .AccHeader{\n            padding: 0.375rem 0.5rem;\n            span{\n              font-size: 0.875rem;\n              font-weight: 500;\n              color: var(--TextColor);\n            }\n          }\n          .AccInfoWrapper{\n            width: 100%;\n            display: grid;\n            grid-template-rows: 1fr;\n            transition: all 0.3s ease-in-out;\n            overflow: hidden;\n            .AccInfo{\n              width: 100%;\n              margin: 0.75rem 1rem;\n              display: grid;\n              grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n              gap: 1.25rem;\n              overflow: hidden;\n              div{\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                gap: 0.375rem;\n                label{\n                  font-size: 0.75rem;\n                  color: var(--AccentColor);\n                  font-weight: 400;\n                }\n                input{\n                  width: calc(100% - 1.5rem);\n                  padding: 0 0.75rem;\n                  background: var(--Invitation);\n                  color: var(--TextColor);\n                  border: none;\n                  height: 32px;\n                  border-bottom: 2px solid var(--Stroke);\n                  font-size: 0.875rem;\n                }\n                input:read-only{\n                  opacity: 0.5;\n                  cursor: not-allowed;\n                }\n                select{\n                  width: calc(100% - 1.5rem);\n                  padding: 0 0.75rem;\n                  background: var(--Invitation);\n                  border: none;\n                  height: 32px;\n                  border-bottom: 2px solid var(--Stroke);\n                  color: var(--TextColor);\n                  font-size: 0.875rem;\n                  option{\n                    background: var(--Foreground);\n                  }\n                }\n                span{\n                  font-size: 0.875rem;\n                  color: #C4C4C4;\n                }\n              }\n            }\n          }\n        }\n      }\n      .Documents{\n        width: 100%;\n        height: 100%;\n        overflow: auto;\n        padding: 0.75rem;\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n        grid-template-rows: repeat(auto-fill, 10rem);\n        gap: 1rem;\n        .DocCont{\n          height: 10rem;\n          display: flex;\n          flex-direction: column;\n          border-radius: 0.5rem;\n          border: 0.0625rem solid var(--Background);\n          .Document{\n            flex: 1;\n            padding: 0.5rem;\n            overflow: hidden;\n            img{\n              width: 100%;\n            }\n          }\n        }\n        .DocDetail{\n        width: 100%;\n          padding: 0 0.5rem;\n          height: 2.5rem;\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n          .DocName{\n            flex: 1;\n            font-size: clamp(0.625rem, 1vw, 0.875rem);\n            font-weight: 700;\n            color: var(--TextColor);\n            white-space: nowrap;\n          }\n          svg{\n            cursor: pointer;\n            path{\n              fill: var(--TextColor);\n            }\n          }\n          svg:hover{\n            path{\n              fill: var(--AccentColor);\n            }\n          }\n        }\n      }\n    }\n  }\n  .LoaderContainer{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #2C2C2C50;\n    z-index: 1;\n  }\n}\n\n@media (max-width: 650px) {\n  .AccountSettings{\n    flex-direction: column;\n    .Details{\n      height: auto;\n      width: 100%;\n      .DetailsContainer{\n        .Detail{\n          display: grid;\n          grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));\n          div{\n            align-items: center;\n          }\n        }\n      }\n    }\n    .Informations{\n      width: 100%;\n      height: auto;\n    }\n  }\n}\n\n@media (max-width: 450px) {\n  .AccountSettings{\n    .Details{\n      .DetailsContainer{\n        .Detail{\n          grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n        }\n      }\n    }\n  }\n}\n\n@media (max-height: 450px) {\n  .AccountSettings{\n    .Details{\n      .Logo{\n        height: 5rem;\n        div{\n          top: 2.5rem;\n        }\n      }\n      .DetailsContainer{\n        padding: 3rem 0.75rem 0.75rem 0.75rem;\n        overflow: auto;\n        .Detail{\n          margin-top: 1rem;\n          grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
